'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactI18next = require('react-i18next');
var cx = require('classnames');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var Input = require('./Input.js');
var alloyInput_module = require('./alloy-input.module.scss.js');
var CloseIcon = require('../alloy-icon/CloseIcon.js');
var SearchIcon = require('../alloy-icon/SearchIcon.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var SearchInput = react.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, error = _a.error, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, id = _a.id, label = _a.label, onChange = _a.onChange, onClear = _a.onClear, placeholder = _a.placeholder, setError = _a.setError, setValue = _a.setValue, _d = _a.showSearchIcon, showSearchIcon = _d === void 0 ? true : _d, validator = _a.validator, _e = _a.value, value = _e === void 0 ? '' : _e, props = tslib.__rest(_a, ["children", "className", "error", "hideLabel", "id", "label", "onChange", "onClear", "placeholder", "setError", "setValue", "showSearchIcon", "validator", "value"]);
    var t = reactI18next.useTranslation()[0];
    var _f = useDefaultInternalState.default(value, setValue), valueState = _f[0], setValueState = _f[1];
    var _g = useDefaultInternalState.default(error, setError), errorState = _g[0], setErrorState = _g[1];
    var clearHandler = function () {
        setValueState('');
        if (validator) {
            var result = validator('');
            setErrorState(result);
        }
        else {
            setErrorState();
        }
        onClear && onClear();
    };
    return (jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default(className), "data-testid": "search-input" }, { children: jsxRuntime.jsxs(Input.default, tslib.__assign({ className: "".concat(alloyInput_module.default['search-input__input']), error: errorState, hideLabel: hideLabel, id: id, label: label, placeholder: placeholder, onChange: onChange, ref: ref, setError: setErrorState, setValue: setValueState, validator: validator, value: valueState }, props, { children: [children, jsxRuntime.jsxs("span", tslib.__assign({ className: cx__default.default('exclude-global', alloyInput_module.default['input__controls'], (_b = {},
                        _b[alloyInput_module.default['input__controls--label-hidden']] = !label || hideLabel,
                        _b)) }, { children: [valueState ? (jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ alt: t('ORGANIZATIONLIST_CLEARRESULTS'), "aria-label": t('ORGANIZATIONLIST_CLEARRESULTS'), className: cx__default.default(alloyInput_module.default['input__control']), onClick: function () { return clearHandler(); } }, { children: jsxRuntime.jsx(CloseIcon.default, {}) }))) : (''), showSearchIcon && (jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ alt: t('SEARCH_CATALOG'), "aria-label": t('SEARCH_CATALOG'), buttonType: "primary", className: cx__default.default(alloyInput_module.default['input__control']), size: "small", type: "submit" }, { children: jsxRuntime.jsx(SearchIcon.default, {}) })))] }))] })) })));
});
SearchInput.displayName = 'SearchInput';
var SearchInput$1 = SearchInput;

exports.default = SearchInput$1;
//# sourceMappingURL=SearchInput.js.map
